import { Divider } from '@mui/material';
import { Button } from 'design-system';
import { MdAdd } from 'react-icons/md';
import { useFeatures } from 'hooks/useFeatures';
import SearchCardResult from './SearchCardResult';

const SearchAddResult = ({ inputValue, onAdd }: { inputValue: string; onAdd: () => void }) => {
  const { isEnabled } = useFeatures();
  if (!isEnabled('QuotesSearch')) return <SearchCardResult inputValue={inputValue} onSubmit={onAdd} />;
  if (inputValue === '') return null;

  return (
    <>
      <Divider />
      <Button
        fullWidth
        variant="text"
        color="primary"
        startIcon={<MdAdd />}
        onClick={onAdd}
        sx={(theme) => ({ justifyContent: 'flex-start', padding: theme.spacing(1.5, 2) })}
      >
        Add &lsquo;{inputValue}&rsquo;
      </Button>
    </>
  );
};

export default SearchAddResult;
